module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":{"common":{"left":"<b>{value}</b> in common with left query","right":"<b>{value}</b> in common with right query"}}}}')
  delete Component.options._Ctor
}
